import { Tag, Tooltip, Typography } from "antd";
import { useAuth } from "@/auth/AuthProvider";
import { useI18n } from "@/i18n";

function msUntil(iso: string): number {
  return new Date(iso).getTime() - Date.now();
}

/**
 * The marketplace's ship-by deadline (SLA): late in red, within a day in
 * orange, otherwise the time it is due.
 */
export function ShipBy({ at, done }: { at: string | null | undefined; done?: boolean }) {
  const { t, formatDateTime } = useI18n();
  const { me } = useAuth();
  if (!at) return <Typography.Text type="secondary">—</Typography.Text>;
  const tz = me?.workspace?.timezone;
  const left = msUntil(at);
  const when = formatDateTime(at, tz);
  if (done) return <span className="z-num">{when}</span>;
  if (left < 0) {
    return (
      <Tooltip title={when}>
        <Tag color="error">{t("orders.shipBy.late")}</Tag>
      </Tooltip>
    );
  }
  if (left < 24 * 3600_000) {
    const hours = Math.max(1, Math.round(left / 3600_000));
    return (
      <Tooltip title={when}>
        <Tag color="warning">{t("orders.shipBy.inHours", { n: hours })}</Tag>
      </Tooltip>
    );
  }
  return <span className="z-num">{when}</span>;
}
